/**
 * IL TASK IN BACHECA — sezione `board` del suo `EntityTypeDescriptor` (TS-117).
 *
 * È il gemello di `quotationBoard`, e la somiglianza è il punto: da qui in avanti mettere un'entità
 * in bacheca è scrivere **questo file** e registrarlo. Niente colonne, niente DDL, niente pagina
 * dedicata — la pagina della bacheca non conosce né il task né il preventivo.
 *
 * I task si caricano dal REST **del task** con `?kanbanId=`: è il server a risolvere quali
 * appartengono alla board, e il DTO che torna è quello pieno, così la card mantiene scadenza,
 * priorità e assegnatario.
 *
 * <b>`currentStateId` non è un campo del task a database</b>, è una riga di `PipelineMembership`
 * che il server risolve prima di rispondere. Da qui non si vede la differenza, ed è voluto: la
 * bacheca chiede «in che colonna sei», non «dove tieni quel dato».
 *
 * `taskApi` si importa **dinamicamente**, come in `quotationBoard` e come fanno `resolveLabel` e
 * `search` nel registro: il modulo api non deve finire nel percorso di boot, altrimenti si riapre
 * il ciclo di import che `coreEntityRegistration` evita per costruzione. La card invece è un import
 * statico: disegna e basta, e non torna indietro al registro.
 */

import type { EntityTypeDescriptor, Page } from '@crm/contracts';
import { TaskKanbanCard } from './TaskKanbanCard';
import type { Task } from './taskTypes';

type BoardSection = NonNullable<EntityTypeDescriptor['board']>;

/** Il descrittore parla di record generici; qui sotto sono task, e il cast sta tutto qui. */
const asTask = (item: Record<string, unknown>) => item as unknown as Task;

export const taskBoard: BoardSection = {
  // pageSize alto e non paginazione: la bacheca mostra tutte le colonne insieme, e una card mancante
  // non si distingue da una card filtrata via.
  loadItems: async (kanbanId, groupId) => {
    const { taskApi } = await import('./taskApi');
    const page = await taskApi.getAll(groupId, { kanbanId, pageSize: 1000 });

    return page as unknown as Page<Record<string, unknown>>;
  },

  idOf: (item) => asTask(item).taskId,

  stateIdOf: (item) => asTask(item).currentStateId ?? 0,

  move: async (id, pipelineStateId) => {
    const { taskApi } = await import('./taskApi');

    await taskApi.update({ taskId: id, currentStateId: pipelineStateId });
  },

  Card: ({ item }) => <TaskKanbanCard task={asTask(item)} />,
};
